import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_brgwq19hx1: FaireBrandEntity = {
  token: "b_brgwq19hx1",
  type: "brand",
  name: "Earths Elements Wholesale",
  avatarUrl:
    "https://cdn.faire.com/fastly/614f20762bbd6e444ded0057f3b79235d616d4071e2d0678dc1057a9a0dd54c2.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/278f615518e0a71b6aa62540a5da1b3f1d3659cee8674fc69e311e8e73b178cf.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/614f20762bbd6e444ded0057f3b79235d616d4071e2d0678dc1057a9a0dd54c2.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/278f615518e0a71b6aa62540a5da1b3f1d3659cee8674fc69e311e8e73b178cf.jpeg",
  location: "Vista, CA, USA",
  minimumOrderDollars: 208,
  rating: 4.9,
  reviewCount: 416,
  isInsider: true,
  description:
    "Welcome to Earths Elements Wholesale, where we blend passion, craftsmanship, and a deep respect for nature to bring you consciously chosen products from around the world that make prefect gifts for any occasion.\n\nEmbracing the new age of holistic living, we believe in nurturing the interconnectedness of body, mind, and soul. Our products are designed to foster balance and well-being, reflecting our commitment to sustainability and authenticity. \n\nFounded by Hem Rai, a former Sherpa from Nepal, our mission is to connect people with the Earth. We proudly source our products responsibly, ensuring you receive the finest, most genuine pieces that align with your values.",
  meta: {
    source: "api",
    importedAt: "2026-03-27T00:06:29.386Z",
    importedBy: "entity-db-cli",
  },
};
